import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";
import Headshot from "../components/Headshot";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>Our Leadership - Elm Street</title>
        <meta name="description" content="Our Leadership Team. Thinkers. Innovators. Over-Achievers." />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/leadership" />
        <meta property="og:title" content="Our Leadership - Elm Street" />
        <meta property="og:description" content="Our Leadership Team. Thinkers. Innovators. Over-Achievers." />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />

      <div
        style={{
          backgroundImage: "url('leadershipbg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
        alt="Elm Street Leadership"
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  height: "350px",
                }}
              >
                <div>
                  <Typography variant="h2" component="h1">
                    Leadership
                    <br />
                    <span style={{ color: mainTheme.palette.secondary.main }}>team</span>
                  </Typography>
                  <p>Thinkers. Innovators. Over-Achievers.</p>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <Container maxWidth="lg" style={{ marginTop: "88px", marginBottom: "68px" }}>
        <Grid container columnSpacing={16}>
          <Grid item md={4} sm={6} xs={12} style={{ paddingBottom: "24px" }}>
            <Headshot src="/headshots/alange.jpg" name="Alex Lange" title="Chief Executive Officer" alt="Alex Lange" />
          </Grid>
          <Grid item md={4} sm={6} xs={12} style={{ paddingBottom: "24px" }}>
            <Headshot src="/headshots/kmellick.jpg" name="Kim Mellick" title="Chief of Staff" alt="Kim Mellick" />
          </Grid>
          <Grid item md={4} sm={6} xs={12} style={{ paddingBottom: "24px" }}>
            <Headshot
              src="/headshots/smcgee.jpg"
              name="Shannon McGee"
              title="General Manager, IXACT Contact and Morris Marketing"
              alt="Shannon McGee"
            />
          </Grid>
          <Grid item md={4} sm={6} xs={12} style={{ paddingBottom: "24px" }}>
            <Headshot
              src="/headshots/lralls.jpg"
              name="Lee Ralls"
              title="Vice President of Engineering"
              alt="Lee Ralls"
            />
          </Grid>
          <Grid item md={4} sm={6} xs={12} style={{ paddingBottom: "24px" }}>
            <Headshot
              src="/headshots/morlandi.png"
              name="Marino Orlandi"
              title="Vice President of Enterprise Partnerships"
              alt="Marino Orlandi"
            />
          </Grid>
          <Grid item md={4} sm={6} xs={12} style={{ paddingBottom: "24px" }}>
            <Headshot
              src="/headshots/moleary.jpg"
              name="Meagan O'Leary"
              title="Senior Director of Marketing"
              alt="Meagan O'Leary"
            />
          </Grid>
          <Grid item md={4} sm={6} xs={12} style={{ paddingBottom: "24px" }}>
            <Headshot
              src="/headshots/kkizer.jpg"
              name="Katie Kizer"
              title="Director of Operations & Customer Service"
              alt="Katie Kizer"
            />
          </Grid>
        </Grid>
      </Container>

      {/* <div style={{ backgroundColor: "#f7f7f7" }}>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "35px",
            paddingBottom: "65px",
          }}
        >
          <div style={{ paddingTop: "65px" }}>
            <Typography variant="h4" component="h4" style={{ textAlign: "center" }}>
              <span style={{ color: "#f69c26" }}>OUR</span> INVESTORS, SUPPORTS &amp; PARTNERS.
            </Typography>
          </div>

          <div
            style={{
              color: "#FFFFFF",
              alignItems: "center",
              display: "flex",
              flexDirection: "row",
              textAlign: "center",
              justifyContent: "center",
            }}
          >
            <Grid container spacing={8}>
              <Grid item xs={12}>
                <div>
                  <a href="https://www.aquiline.com/">
                    <Image src="/aquiline.png" width="600px" height="254px" alt="Aquiline Investment Partners LLC" />
                  </a>
                </div>
              </Grid>
              <Grid item xs={12} style={{ paddingBottom: "20px", paddingTop: "0px" }}>
                <div style={{ paddingTop: "12px" }}>
                  <Button variant="contained" color="secondary" href="https://www.aquiline.com/" target="_blank">
                    visit aquiline.com
                  </Button>
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div> */}

      <MainFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
